import RewardPoolContent from "./RewardPoolContent";

export default RewardPoolContent;